// extracted by mini-css-extract-plugin
export default {"page":"yX-z","cartModal":"zX-z","checkout":"AX-z","placeholder":"BX-z","account":"CX-z"};